import axios from 'axios';

const env = process.env.REACT_APP_STAGE;
// const env = 'qa';
const startPath = '/api/v1/app-service';
let backendUrl;
let logicAppUrl;
let logicAppQueryString;

switch (env) {
  case 'local':
    backendUrl = 'http://localhost:8085';
    logicAppUrl = 'https://prod-91.westeurope.logic.azure.com:443';
    logicAppQueryString =
      '/workflows/600e6700e4d549b78196209a649e7401/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=yaAU9vNl2hEHEQ7c2wqIVKsCuPR7K19wcWJ9xzyK2D4';
    break;
  case 'dev':
    backendUrl = 'https://wolfback.rcgwd.iasp.tgscloud.net';
    logicAppUrl = 'http://localhost:8085';
    logicAppQueryString = '';
    break;
  case 'qa':
    backendUrl = 'https://wolfback.rcgwq.iasp.tgscloud.net';
    logicAppUrl = 'https://prod-91.westeurope.logic.azure.com:443';
    logicAppQueryString =
      '/workflows/600e6700e4d549b78196209a649e7401/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=yaAU9vNl2hEHEQ7c2wqIVKsCuPR7K19wcWJ9xzyK2D4';
    break;
  case 'prod':
    backendUrl = 'https://wolfback.rcgwp.iasp.tgscloud.net';
    logicAppUrl = 'https://prod-196.westeurope.logic.azure.com:443';
    logicAppQueryString =
      '/workflows/4bd37e773d6d485f82d14418344e5f17/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=WozBgMPY4cQChQ0HNFaAtAvhiWg5Qkd5kmZXk9ZM55M';
    break;
  default:
    backendUrl = 'http://localhost:8085';
    logicAppUrl = 'http://localhost:8085';
    logicAppQueryString = '';
}
const ApiRequest = axios.create({
  baseURL: `${backendUrl + startPath}`,
});

export const logicAppApiRequest = axios.create({
  baseURL: `${logicAppUrl}`,
});

export const logicAppQueryPath = logicAppQueryString;

function getAccessToken() {
  for (let i = 0; i < window.sessionStorage.length; i += 1) {
    const key = window.sessionStorage.key(i);
    if (key.slice(0, 9) === 'oidc.user') {
      return JSON.parse(window.sessionStorage.getItem(key)).access_token;
    }
  }
  return null;
}

ApiRequest.defaults.headers.common.Authorization = `Bearer ${getAccessToken()}`;
export default ApiRequest;
